import React, { useState } from "react";
import {
    checkPasswordRules, getEmailError,
    getPasswordError,
} from "@rosette/ts/src/auth/validation.js";
import { RosetteForm } from "@/components/form/themed/RosetteForm.js";
import { SubmitButton } from "@/components/form/SubmitButton.js";
import Link from "next/link";
import { PasswordInput } from "@rosette/web_components/src/form/input/PasswordInput.js";
import { SocialSignInButtons } from "@/components/auth/SocialSignInButtons.js";
import { OrSeparator } from "@rosette/web_components/src/generic/OrSeparator.js";
import { FormMessage } from "@rosette/web_components/src/ui/FormMessage.js";
import { Label } from "@rosette/web_components/src/ui/Label.js";
import { TextInput } from "@rosette/web_components/src/ui/TextInput.js";


export function RegisterForm() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmedPassword, setConfirmedPassword] = useState("");

    const emailError = getEmailError(email);
    const passwordRules = checkPasswordRules(password);
    const passwordError = getPasswordError(passwordRules);
    const confirmPasswordError = (password === confirmedPassword ? null : "Passwords do not match");

    const validationError = emailError ?? passwordError ?? confirmPasswordError;

    return (
        <RosetteForm
            title="Register for RoyalUr.net"
            action="/register/submit"
            validationError={validationError}
            backPieces={[
                { label: "Home", href: "/" },
                { label: "Sign in", href: "/login" },
            ]}>

            <SocialSignInButtons redirectPathname={null} />
            <OrSeparator />

            <Label htmlFor="email">Email</Label>
            <TextInput
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required={true} />

            <FormMessage kind="error">
                {email.length === 0 ? "" : emailError}
            </FormMessage>

            <Label htmlFor="password">Password</Label>
            <PasswordInput
                id="password"
                name="password"
                value={password}
                setValue={setPassword}
                autoComplete="new-password"
                required={true} />

            <FormMessage kind="error">
                {password.length === 0 ? "" : passwordError}
            </FormMessage>

            <Label htmlFor="confirm_password">Confirm Password</Label>
            <PasswordInput
                id="confirm_password"
                value={confirmedPassword}
                setValue={setConfirmedPassword}
                autoComplete="new-password"
                required={true} />

            <FormMessage kind="error">
                {confirmedPassword.length === 0 && password.length > 0 && passwordError !== null
                    ? "" : confirmPasswordError}
            </FormMessage>

            <div className="mt-4 w-full">
                <SubmitButton tone="rosette" label="Register" />
            </div>

            <p>
                Already have an account?
                {" "}
                <Link href="/login">
                    Sign in.
                </Link>
            </p>
        </RosetteForm>
    );
}
